import React, { useState, useEffect } from 'react'

//Styles 
import Styles from "./EditTool.module.scss";
import classnames from "classnames";

//Icons
import { ReactComponent as BrightnessIcon } from "../../images/icons/brightness.svg"
import { ReactComponent as SaturationIcon } from "../../images/icons/saturation.svg"
import { ReactComponent as ContrastIcon } from "../../images/icons/contrast.svg"
import { ReactComponent as HueIcon } from "../../images/icons/hue.svg"
import { ReactComponent as RotateLeftIcon } from "../../images/icons/rotate_anticlockwise.svg"
import { ReactComponent as RotateRightIcon } from "../../images/icons/rotate_clockwise.svg"
import { ReactComponent as TempratureIcon } from "../../images/icons/temprature.svg"
import { ReactComponent as TintIcon } from "../../images/icons/tint.svg";
import { ReactComponent as FitIcon } from "../../images/icons/fit.svg";
import { ReactComponent as ContainIcon } from "../../images/icons/contain.svg";
import { ReactComponent as StrechIcon } from "../../images/icons/strech.svg";
import { ReactComponent as CoverIcon } from "../../images/icons/cover.svg";
import { ReactComponent as BWIcon } from "../../images/icons/bw.svg";
import { ReactComponent as InvertIcon } from "../../images/icons/invert.svg";
import { ReactComponent as HDIcon } from "../../images/icons/hd.svg";

//Components
import EditToolController from '../edit-tool-controller/EditToolController'
import Switch from '../switch/Switch';

const EditTool = () => {

    const [brightness, setBrightness] = useState( Number(document.documentElement.style.getPropertyValue(('--brightness'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--brightness')))*100 : 100);
    const [contrast, setContrast] = useState( Number(document.documentElement.style.getPropertyValue(('--contrast'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--contrast')))*100 : 100);
    const [saturation, setSaturation] = useState( Number(document.documentElement.style.getPropertyValue(('--saturation'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--saturation')))*100 :100);
    const [hue, setHue] = useState(0);
    const [temprature, setTemprature] = useState(Number(document.documentElement.style.getPropertyValue(('--temprature-opacity'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--temprature-opacity'))) :0);
    const [tint, setTint] = useState(Number(document.documentElement.style.getPropertyValue(('--tint-opacity'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--tint-opacity'))) :0);
    const [isBWChecked,setIsBWChecked]=useState(false)
    const [isInvertChecked,setInvertChecked]=useState(false)
    var root = document.querySelector(':root');


    useEffect(()=>{
        let satValue = (document.documentElement.style.getPropertyValue("--saturation"))
        let invertValue = (document.documentElement.style.getPropertyValue("--invert"))
        satValue =String(String(satValue).split("(")[1]).split(")")[0]
        invertValue =String(String(invertValue).split("(")[1]).split(")")[0]

        if(Number(satValue)===0){
            setIsBWChecked(true)}
        else {
            setIsBWChecked(false)
        }

        if(Number(invertValue)===1){
            setInvertChecked(true)
        }
        else{
            setInvertChecked(false)
        }
        
        var tempOpacity= Number(document.documentElement.style.getPropertyValue((`--temprature-opacity`)))
        var tempVal= String(document.documentElement.style.getPropertyValue((`--temprature`)));

        if(tempVal==="0, 68, 255")(
            setTemprature(-1000*tempOpacity)
        )
        else{
            setTemprature(1000*tempOpacity)
        }

        var tintOpacity= Number(document.documentElement.style.getPropertyValue((`--tint-opacity`)))
        var tintVal= String(document.documentElement.style.getPropertyValue((`--tint`)));

        if(tintVal==="0, 255, 42")(
            setTint(-1000*tintOpacity)
        )
        else{
            setTint(1000*tintOpacity)
        }

        var hueVal = String(document.documentElement.style.getPropertyValue((`--hue`)));
        var startIndex = hueVal.indexOf("(");
        var endIndex = hueVal.indexOf("de", startIndex + "(".length);
        hueVal =  hueVal.substring(startIndex + "(".length, endIndex);
        setHue(Number(hueVal.split("deg")[0]))
    })

    const handleChange = (id: string, value: number) => {

        switch (id) {
            case "brightness":
                document.documentElement.style.setProperty((`--${id}`), String(value / 100))
                setBrightness(value);
                break;
            case "contrast":
                document.documentElement.style.setProperty((`--${id}`), String(value / 100))
                setContrast(value);
                break;
            case "saturation":
                document.documentElement.style.setProperty((`--${id}`), `saturate(${value/100})`)
                setSaturation(value);
                break;
            case "hue":
                document.documentElement.style.setProperty((`--${id}`), String(`${value}deg`))
                setHue(value);
                break;
            case "temprature":
                if (value < 0) {
                    document.documentElement.style.setProperty((`--${id}`), `0, 68, 255`);
                    document.documentElement.style.setProperty((`--${id}-opacity`), String(value * -1 / 1000));
                }
                else {
                    document.documentElement.style.setProperty((`--${id}`), `255, 217, 0`);
                    document.documentElement.style.setProperty((`--${id}-opacity`), String(value / 1000));
                }
                setTemprature(value);
                break;
            case "tint":
                if (value < 0) {
                    document.documentElement.style.setProperty((`--${id}`), `0, 255, 42`);
                    document.documentElement.style.setProperty((`--${id}-opacity`), String(value * -1 / 1000));
                }
                else {
                    document.documentElement.style.setProperty((`--${id}`), `234, 0, 255`);
                    document.documentElement.style.setProperty((`--${id}-opacity`), String(value / 1000));
                }
                setTint(value);
                break;
            default:

        }

    }

    const rotateLeft = ()=>{
        const value=Number(document.documentElement.style.getPropertyValue("--rotate").split("deg")[0])-90
        document.documentElement.style.setProperty((`--rotate`), `${value}deg`);
    }

    
    const rotateRight = ()=>{
        const value=Number(document.documentElement.style.getPropertyValue("--rotate").split("deg")[0])+90
        document.documentElement.style.setProperty((`--rotate`), `${value}deg`);
    }

    const handleFitStyle=(fitStyle:string)=>{
        document.documentElement.style.setProperty((`--fitstyle`), fitStyle);
    }

    const invertSaturation=()=>{
        let value = (document.documentElement.style.getPropertyValue("--saturation"))
        setIsBWChecked(!isBWChecked)
        value =String(String(value).split("(")[1]).split(")")[0]
        if(Number(value)===0){
            value="1"
        }
        else {
            value="0"
        }
        document.documentElement.style.setProperty((`--saturation`),`saturate(${value})`);
    }

    const handleInvert=()=>{
        let value = (document.documentElement.style.getPropertyValue("--invert"))
        setInvertChecked(!isInvertChecked)
        value =String(String(value).split("(")[1]).split(")")[0]
        if(Number(value)===1){
            value="0"
        }
        else{
            value="1"
        }
        document.documentElement.style.setProperty((`--invert`),`invert(${value})`);
    }

    return (
        <>
            <div className={Styles.container}>
                <div className={Styles.sliders}>

                    <div className={Styles.left_edit}>
                        <div className={Styles.controller_container}>
                            <EditToolController
                                id={"brightness"}
                                label={"Brightness"}
                                icon={<BrightnessIcon />}
                                onValueChange={(value: number) => { handleChange("brightness", value) }}
                                minValue={0}
                                maxValue={100}
                                defaultValue={brightness}
                            />
                        </div>
                        <div className={Styles.controller_container}>
                            <EditToolController
                                id={"contrast"}
                                label={"Contrast"}
                                icon={<ContrastIcon />}
                                onValueChange={(value: number) => { handleChange("contrast", value) }}
                                minValue={0}
                                maxValue={200}
                                defaultValue={contrast}
                            />
                        </div>
                        <div className={Styles.controller_container}>
                            <EditToolController
                                id={"saturation"}
                                label={"Saturation"}
                                icon={<SaturationIcon />}
                                onValueChange={(value: number) => { handleChange("saturation", value) }}
                                minValue={0}
                                maxValue={200}
                                defaultValue={saturation}
                            />
                        </div>
                    </div>
                    <div className={Styles.right_edit}>
                        <div className={Styles.controller_container}>
                            <EditToolController
                                id={"hue"}
                                label={"Hue"}
                                icon={<HueIcon />}
                                onValueChange={(value: number) => { handleChange("hue", value) }}
                                minValue={0}
                                maxValue={270}
                                defaultValue={hue}
                            />
                        </div>
                        <div className={Styles.controller_container}>
                            <EditToolController
                                id={"temprature"}
                                label={"Temprature"}
                                icon={<TempratureIcon />}
                                onValueChange={(value: number) => { handleChange("temprature", value) }}
                                minValue={-125}
                                maxValue={125}
                                defaultValue={temprature}
                            />
                        </div>
                        <div className={Styles.controller_container}>
                            <EditToolController
                                id={"tint"}
                                label={"Tint"}
                                icon={<TintIcon />}
                                onValueChange={(value: number) => { handleChange("tint", value) }}
                                minValue={-125}
                                maxValue={125}
                                defaultValue={tint}
                            />
                        </div>
                    </div>

                </div>

            <div className={classnames(Styles.singleButtons)}>
                <div className={Styles.icon_container} onClick={rotateLeft} >
                    <RotateLeftIcon width={20} height={30} />
                </div>
                <div className={Styles.icon_container} onClick={rotateRight}>
                    <RotateRightIcon width={20} height={30} />
                </div>
                <div className={Styles.icon_container}  onClick={()=>{handleFitStyle("cover")}}  >
                    <FitIcon width={20} height={30} />
                </div>
                <div className={Styles.icon_container}  onClick={()=>{handleFitStyle("95% 90%")}}  >
                    <ContainIcon width={20} height={30} />
                </div>
                <div className={Styles.icon_container}  onClick={()=>{handleFitStyle("fill")}}  >
                    <StrechIcon width={20} height={30} />
                </div>
                <div className={Styles.icon_container}  onClick={()=>{handleFitStyle("contain")}}  >
                    <CoverIcon width={20} height={30} />
                </div> 
                <Switch
                    isChecked={isBWChecked}
                    onChange={invertSaturation}
                    name="saturationBWInvert"
                    icon={<BWIcon width={15} height={20} />}
                    isDisabled={false}
                />
                <Switch
                    isChecked={isInvertChecked}
                    onChange={handleInvert}
                    name="saturationInvert"
                    icon={ <InvertIcon width={10} height={20} />}
                    isDisabled={false}
                /> 
                <Switch
                    isChecked={false}
                    onChange={()=>{}}
                    name="saturationBWInvert"
                    icon={<HDIcon width={15} height={20} />}
                    isDisabled={true}
            />
            </div>
            
            </div>
        </>
    )
}

export default EditTool
